export function parseTimestamp(timestamp: string): number {
    if (
        !/\d{2}:\d{2}/.test(timestamp) ||
        !/\d{2}:\d{2}\.\d{3}/.test(timestamp)
    ) {
        return NaN;
    }

    let [minutes, seconds] = timestamp.split(":");
    let milliseconds = "000";
    if (seconds.includes(".")) {
        [seconds, milliseconds] = seconds.split(".");
    }

    const totalSeconds = Number(minutes) * 60 + Number(seconds);

    return Number(totalSeconds) * 1000 + Number(milliseconds);
}
